<div class="dataset noflex object-icon universe-background">
    <div class="middle"><i class='icon dku-icon-feature-24'></i></div>
</div>
<h2 class="flex ellipsed" matTooltip="{{selectedFeature._source.name}}">
    <span [innerHtml]="formatFeatureName() | escapeHighlightedHtml"></span>
</h2>
